const copyToClipboard = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M0 14V0h14v1.65H1.65V14zM4 4v12h12V4zm10.5 10.5h-9v-9h9z" clip-rule="evenodd"/></svg>',
};

export { copyToClipboard as default };
